import { render, staticRenderFns } from "./TranferUser.vue?vue&type=template&id=c8fe8558&scoped=true"
import script from "./TranferUser.vue?vue&type=script&lang=js"
export * from "./TranferUser.vue?vue&type=script&lang=js"
import style0 from "./TranferUser.vue?vue&type=style&index=0&id=c8fe8558&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fe8558",
  null
  
)

export default component.exports